import React from 'react';
import ContactUs from '../ContactUs/ContactUs';
import AboutUs from '../ContactUs/AboutUs';
import './Contact.css';

const Contact = () => {
    return ( 
        <div className='contact-layer'>
            <div className='col-12 col-lg-7 '><AboutUs /></div>
            <div className='col-12 col-lg-5 '><ContactUs /></div>
        </div>
     );
}
 
export default Contact;